import React from 'react';

const IconYoutube = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H24V24H0z" transform="translate(-1 -4)" />
      <path fill={color} d="M12.238 4c1.227.006 6.832.051 8.357.463.947.254 1.692 1.005 1.945 1.957.46 1.727.46 5.33.46 5.33s0 3.603-.46 5.33c-.253.952-.998 1.703-1.945 1.957C18.88 19.5 12 19.5 12 19.5s-6.88 0-8.595-.463c-.947-.254-1.692-1.005-1.945-1.957-.403-1.511-.453-4.459-.46-5.172v-.316c.007-.713.057-3.66.46-5.172.253-.952.998-1.703 1.945-1.957 1.525-.412 7.13-.457 8.357-.462zM9.75 8.48v6.542l5.75-3.27-5.75-3.272z" transform="translate(-1 -4)" />
    </g>
  </svg>
);

export default IconYoutube;
